module.exports = __webpack_public_path__ + "img/kankou_9.3326bc96.jpg";